import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { PreEnrolledAccountsService } from './pre-enrolled-accounts.service';
import {
    IPreInrolatInfo,
    IPreInrolatEditPayload,
} from './pre-enrolled-accounts.interface';
import { helper } from 'src/environments/helper';
import Swal from 'sweetalert2';
import { AddPreInrolatComponent } from './add-pre-inrolat/add-pre-inrolat.component';
import { EditPreInrolatComponent } from './edit-pre-inrolat/edit-pre-inrolat.component';
import { InfoPreInrolatComponent } from './info-pre-inrolat/info-pre-inrolat.component';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'app-pre-enrolled-accounts',
    templateUrl: './pre-enrolled-accounts.component.html',
    styleUrls: ['./pre-enrolled-accounts.component.scss'],
})
export class PreEnrolledAccountsComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    isLoading = false;
    showCard = false;

    filtersForm!: FormGroup;

    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    sursaParameters: { key: string; value: number }[] = [
        { key: '--Alegeți--', value: -1 },
        { key: 'DGITL', value: 1 },
        { key: 'URBANISM', value: 2 },
        { key: 'DGASPC', value: 3 },
    ];

    initialFiltersFormValues = {
        cnp_cui: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        active: '-1',
        approved: -1,
    };

    buildFiltersForm() {
        this.filtersForm = new FormGroup({
            cnp_cui: new FormControl(''),
            first_name: new FormControl(''),
            last_name: new FormControl(''),
            phone: new FormControl(''),
            email: new FormControl(''),
            active: new FormControl('-1'),
            approved: new FormControl('-1'),
            source: new FormControl(-1),
        });
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    resetForm() {
        this.filtersForm.reset(this.initialFiltersFormValues);

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.inrolat.getInrolatiDT;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private preEnrolledAccountsService: PreEnrolledAccountsService
    ) { }

    ngOnInit(): void {
        this.buildFiltersForm();
        this.renderDT();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            pageLength: 25,
            responsive: true,
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.filters = this.filtersForm.value;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'CI/CUI',
                    data: null,
                    orderable: false,
                    render: (row: any) => {
                        let data;

                        if (row.cui !== null && row.cui !== '') {
                            data = row.cui;
                        } else {
                            data = row.cnp
                        }

                        return data;
                    }
                },
                {
                    title: 'Cetățean/Companie',
                    data: null,
                    orderable: false,
                    render: (row: any) => {
                        const userUrl = '/assets/icons/icon-user.svg';
                        const societateUrl = '/assets/icons/companii.svg';
                        let societate;
                        if (row.f_nume !== null && row.f_nume !== '') {
                            societate = `
                                        <img class="me-1" src="${societateUrl}" alt="Image" style="width: 20px; height: 20px;">
                                        <span>${row.f_nume}</span>
                                        `;
                        } else {
                            societate = '';
                        }

                        return `
                            <img src="${userUrl}" alt="Image" style="width: 20px; height: 20px;">
                            <span>${row.prenume} ${row.nume}</span> <br/>
                            ${societate}
                        `;
                    }
                },
                {
                    title: 'Telefon',
                    data: 'telefon',
                    orderable: false,
                },
                {
                    title: 'Email',
                    data: 'email',
                    orderable: false,
                },
                {
                    title: 'Activ',
                    data: null,
                    orderable: false,
                    render: (row: any) => {
                        if (row.active === true) {
                            return `<span style="color: #00a65a;">Activ</span>`;
                        } else {
                            return `<span style="color: #dd4b39;">Inactiv</span>`;
                        }
                    }
                },
                {
                    title: 'Cont generat/confirmat',
                    data: null,
                    orderable: false,
                    render: (row: any) => {
                        if (row.confirmed === 0) {
                            return '<span>Neactivat</span>';
                        } else {
                            return `<span style="color: blue;">Confirmat (${row.confirmed_date}) - ${row.confirmed_source}</span>`;
                        }
                    }
                },
                {
                    title: 'Cod unic/Parolă',
                    data: 'pin',
                    orderable: false,
                },
                {
                    title: 'Actualizat',
                    data: 'updated_at',
                    orderable: false,
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: () => {
                        return `<div className:"d-flex align-center">
                            <button class="action-btn edit ms-1">
                                <img class="btn-img" src="../../../../assets/icons/edit.svg" alt="edit"/>
                            </button>
                            <button class="action-btn view ms-1">
                                <img class="btn-img" src="../../../../assets/icons/view.svg" alt="view"/>
                            </button>
                            </div>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit');
                const viewicon = lastTd?.querySelector('.view');

                if (editIcon) {
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (viewicon) {
                    viewicon.addEventListener('click', () => {
                        this.openInfoDialog(data);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddPreInrolatComponent, {
            ...this.dialogService.getDialogConfig(),
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }

    openInfoDialog(data: IPreInrolatInfo) {
        const dialogRef = this.dialog.open(InfoPreInrolatComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }

    openEditDialog(data: IPreInrolatEditPayload) {
        const dialogRef = this.dialog.open(EditPreInrolatComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }
}
